'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textractStatus = exports.calculateCreditCardFee = exports.CREDIT_CARD_PROCESSING_FEE_NAME = exports.MainReducer = exports.isSupportedCurrency = exports.currencies = exports.getTitle = exports.getDescription = exports.ScoreCalculator = exports.Config = undefined;

var _events = require('./utilities/events');

Object.defineProperty(exports, 'getDescription', {
  enumerable: true,
  get: function get() {
    return _events.getDescription;
  }
});
Object.defineProperty(exports, 'getTitle', {
  enumerable: true,
  get: function get() {
    return _events.getTitle;
  }
});

var _currencyTypes = require('./utilities/currency-types');

Object.defineProperty(exports, 'currencies', {
  enumerable: true,
  get: function get() {
    return _currencyTypes.currencies;
  }
});
Object.defineProperty(exports, 'isSupportedCurrency', {
  enumerable: true,
  get: function get() {
    return _currencyTypes.isSupportedCurrency;
  }
});

var _reducers = require('./redux/reducers');

Object.defineProperty(exports, 'MainReducer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_reducers).default;
  }
});

var _fees = require('./utilities/fees');

Object.defineProperty(exports, 'CREDIT_CARD_PROCESSING_FEE_NAME', {
  enumerable: true,
  get: function get() {
    return _fees.CREDIT_CARD_PROCESSING_FEE_NAME;
  }
});
Object.defineProperty(exports, 'calculateCreditCardFee', {
  enumerable: true,
  get: function get() {
    return _fees.calculateCreditCardFee;
  }
});

var _textractStatuses = require('./utilities/textract-statuses');

Object.defineProperty(exports, 'textractStatus', {
  enumerable: true,
  get: function get() {
    return _textractStatuses.textractStatus;
  }
});

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

var _scores = require('./utilities/scores');

var _scores2 = _interopRequireDefault(_scores);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.Config = _config2.default;
exports.ScoreCalculator = _scores2.default;


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/index.js
// module id = 9
// module chunks = 0